import { json2csv } from 'json-2-csv';
import React from 'react';

export function parseObjectToURLQuery(object) {
    return Object.keys(object).reduce(
        (accumulator, paramKey) => {
            if(object[paramKey]){
                if(Array.isArray(object[paramKey])){
                    return accumulator + 
                    object[paramKey].reduce(
                        (accumulator2, value) => accumulator2 + `&${paramKey}=${value}` 
                    , '');
                } else{
                    return accumulator + `&${paramKey}=${object[paramKey]}`;
                }
            } else {
                return accumulator
            }
        }, ''
    )
}

export function downloadCSV(dados, nomeCSV, delimiter = ';') {
    try {
        const csv = json2csv(dados, { delimiter: { field: delimiter } })
        const BOM = new Uint8Array([0xEF,0xBB,0xBF]);
        const blob = new Blob([BOM, csv], { type: 'text/csv;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', nomeCSV);
        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);
    } catch (error) {
        console.error('Error converting JSON to CSV:', error);
    }
}